import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { WS_TYPES, MAIN_BOARD, pdfBoardId } from "../wsProtocol";

const COLORS = ["#111827", "#e53935", "#1e88e5", "#43a047", "#fb8c00", "#8e24aa"];
const TOOLS = [
  { name: "pen", icon: "✏️" },
  { name: "text", icon: "🔤" },
  { name: "hl", icon: "🖍️" },
  { name: "eraser", icon: "🧽" },
];
// default stroke/font size per tool (text is multiplied x6 when drawn)
const SIZES = { pen: [2, 4, 8], text: [3, 5, 8], hl: [12, 18, 28], eraser: [20, 30, 50] };

const StudentToolbar = ({ tool, setTool, send, pdf }) => {
  const { t } = useTranslation();
  const currentBoard = pdf && pdf.url ? pdfBoardId(pdf.url, pdf.page) : MAIN_BOARD;
  const sizes = SIZES[tool.name] || SIZES.pen;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        flexWrap: "wrap",
        background: "#fff",
        borderRadius: "12px",
        padding: "6px 10px",
        marginBottom: "8px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
      }}
    >
      {TOOLS.map((item) => (
        <Tooltip key={item.name} title={t(`wb_tool_${item.name}`)}>
          <IconButton
            size="small"
            onClick={() => setTool((prev) => ({ ...prev, name: item.name, size: SIZES[item.name][1] }))}
            sx={{
              background: tool.name === item.name ? "rgba(0,145,247,0.18)" : "none",
              borderRadius: "8px",
            }}
          >
            {item.icon}
          </IconButton>
        </Tooltip>
      ))}

      <Box sx={{ width: "1px", height: 22, background: "rgba(0,0,0,0.12)", marginInline: "2px" }} />

      {COLORS.map((color) => (
        <Box
          key={color}
          onClick={() => setTool((prev) => ({ ...prev, color }))}
          sx={{
            width: 20,
            height: 20,
            borderRadius: "50%",
            backgroundColor: color,
            cursor: "pointer",
            border: tool.color === color ? "2px solid #111" : "2px solid transparent",
            transform: tool.color === color ? "scale(1.15)" : "none",
          }}
        />
      ))}

      <Box sx={{ width: "1px", height: 22, background: "rgba(0,0,0,0.12)", marginInline: "2px" }} />

      {/* size picker — for text these are font sizes */}
      {sizes.map((size, index) => (
        <Tooltip key={size} title={t(["wb_size_small", "wb_size_medium", "wb_size_large"][index])}>
          <IconButton
            size="small"
            onClick={() => setTool((prev) => ({ ...prev, size }))}
            sx={{
              borderRadius: "8px",
              background: tool.size === size ? "rgba(0,0,0,0.1)" : "none",
              width: 30,
              height: 30,
            }}
          >
            {tool.name === "text" ? (
              <Box component="span" sx={{ fontWeight: 800, fontSize: `${0.65 + index * 0.2}rem`, lineHeight: 1 }}>أ</Box>
            ) : (
              <Box component="span" sx={{ width: Math.min(size, 16), height: Math.min(size, 16), borderRadius: "50%", background: "#111" }} />
            )}
          </IconButton>
        </Tooltip>
      ))}

      <Box sx={{ width: "1px", height: 22, background: "rgba(0,0,0,0.12)", marginInline: "2px" }} />

      <Tooltip title={t("wb_tool_undo")}>
        <IconButton
          size="small"
          onClick={() => send({ t: WS_TYPES.DRAW_UNDO, board: currentBoard })}
          sx={{ borderRadius: "8px" }}
        >
          ↩️
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default StudentToolbar;
